<template>
  <div>
    <v-card
      ><v-card-text>
        <menuSuperviseur />
        <v-card flat>
          <v-card-text>
            <vue-excel-xlsx
              :data="groupesDeRegionsScroll"
              :columns="columnGroupes"
              :filename="'groupes'"
              :sheetname="'groupes'"
            >
              <v-btn class="primary">
                <v-icon>mdi-microsoft-excel</v-icon> Télécharger</v-btn
              >
            </vue-excel-xlsx>

            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Groupe
                    </th>
                    <th class="text-left">
                      projets
                    </th>
                    <th class="text-left">
                      Animateur
                    </th>
                    <th class="text-left">
                      Région
                    </th>
                    <th class="text-left">
                      District
                    </th>
                    <th class="text-left">
                      Commune
                    </th>
                    <th class="text-left">
                      Fokontany
                    </th>
                    <th class="text-left"></th>
                    <th class="text-left"></th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(groupe, index) in groupesDeRegionsScroll"
                    :key="index"
                  >
                    <td>{{ groupe.nom_groupe }}</td>
                    <td>
                      <ul>
                        <li
                          v-for="(projets, indexprojets) in groupe.projets"
                          :key="indexprojets"
                        >
                          {{ projets.ll_programme }}
                        </li>
                      </ul>
                    </td>
                    <td>{{ groupe.nom_responsable }}</td>
                    <td>{{ groupe.ll_region }}</td>
                    <td>{{ groupe.ll_district }}</td>
                    <td>{{ groupe.ll_commune }}</td>
                    <td>{{ groupe.ll_fokontany }}</td>
                    <td>
                      <v-btn
                        outlined
                        x-small
                        fab
                        dark
                        class="success mr-2"
                        @click="detailsGroupe(groupe)"
                      >
                        <v-icon>chevron_right</v-icon>
                      </v-btn>
                    </td>
                    <td><DialogAssignGroupToUser :groupe="groupe" /></td>
                    <td>
                      <template v-if="groupe.projets.length === 0">
                        <DialogLinkGroupAndProjets :groupe="groupe" />
                      </template>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="GetGroupesDeRegionsScroll(regionSupervisees)" color="success">({{groupesDeRegionsScroll.length}}) Charger la suite</v-btn>
        <v-spacer />
      </v-card-actions>
      <v-card-actions>
      
        <Navigation :elements="SuperviseurNavigation" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    let self = this;
    this.GetGroupesDeRegionsScrollInitial(self.regionSupervisees);
  },
  components: {
    menuSuperviseur: require("@/components/superviseur/menuSuperviseur.vue")
      .default,
    Navigation: require("@/components/Navigation.vue").default,
    DialogLinkGroupAndProjets: require("@/components/DialogLinkGroupAndProjets.vue")
      .default,
    DialogAssignGroupToUser: require("@/components/superviseur/DialogAssignGroupToUser.vue")
      .default,
  },
  data() {
    return {
      columnGroupes: [
        {
          label: "Nom",
          field: "nom_groupe",
        },
        {
          label: "Animateur",
          field: "nom_responsable",
        },
        {
          label: "Région",
          field: "ll_region",
        },
        {
          label: "District",
          field: "ll_district",
        },
        {
          label: "Commune",
          field: "ll_commune",
        },
        {
          label: "Fokontany",
          field: "ll_fokontany",
        },
      ],
    };
  },
  methods: {
    detailsGroupe(item) {
      this.$router.push({ path: `/detailsGroupe/${item.id}` });
    },

    ...mapActions({
      //GetArrayRegions: "Utils/GetArrayRegions",
      GetGroupesDeRegions: "Groupes/GetGroupesDeRegions",
      GetGroupesDeRegionsScrollInitial: "Groupes/GetGroupesDeRegionsScrollInitial",
      GetGroupesDeRegionsScroll: "Groupes/GetGroupesDeRegionsScroll",
    }),
  },

  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      groupes: (state) => state.Groupes.groupesDeRegions,
      groupesDeRegionsScroll: (state) => state.Groupes.groupesDeRegionsScroll,
      SuperviseurNavigation: (state) => state.Navigation.SuperviseurNavigation,
      regionSupervisees: (state) => state.Utils.listeRegionsSupervisees,
      superviseurs: (state) =>
        _.filter(state.Users.identifiants, { role: "superviseur", active: 1 }),
    }),
  },
};
</script>

<style lang="scss" scoped></style>
